module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"timeSlotOfArrival":"Time Slot of Arrival","specialEvents":"Events","book":{"text":"Book now","link":"/booking/overview"},"reserve":{"text":"Reserve now","link":"/reservation/overview"}}}')
  delete Component.options._Ctor
}
